import { render } from "./ModelListEditor.vue?vue&type=template&id=10128b8a&scoped=true&ts=true&lang=html"
import script from "./ModelListEditor.vue?vue&type=script&lang=ts"
export * from "./ModelListEditor.vue?vue&type=script&lang=ts"

import "./ModelListEditor.vue?vue&type=style&index=0&id=10128b8a&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/test-saas-doctor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10128b8a"]])

export default __exports__